import React, { useEffect, useRef } from "react";

// Images smaller than this are icons/logos; leave them at their CSS size.
const MIN_FIT_WIDTH = 150;

// Grow images toward the full width of the text column, using only the height
// the modal has left before hitting its max-height. If the modal is already at
// its max (the text scrolls), images go full width but never taller than the
// visible area.
function fitImages(body) {
  const modal = body.closest(".news-modal");
  if (!modal) return;
  const images = [...body.querySelectorAll("img")];
  images.forEach((img) => {
    img.style.height = "";
    img.style.maxHeight = "";
  });

  const bodyStyle = getComputedStyle(body);
  const columnWidth =
    body.clientWidth -
    parseFloat(bodyStyle.paddingLeft) -
    parseFloat(bodyStyle.paddingRight);
  const scrolls = body.scrollHeight > body.clientHeight + 1;
  let slack = scrolls
    ? 0
    : Math.max(
        0,
        parseFloat(getComputedStyle(modal).maxHeight) - modal.offsetHeight
      );
  const maxImageHeight = body.clientHeight + slack;

  images.forEach((img) => {
    const naturalWidth = img.naturalWidth || Number(img.getAttribute("width"));
    const naturalHeight =
      img.naturalHeight || Number(img.getAttribute("height"));
    if (!naturalWidth || !naturalHeight || naturalWidth < MIN_FIT_WIDTH) return;

    const currentHeight = img.getBoundingClientRect().height;
    let target = Math.min(
      (columnWidth * naturalHeight) / naturalWidth,
      maxImageHeight
    );
    if (!scrolls) target = Math.min(target, currentHeight + slack);
    slack -= Math.max(0, target - currentHeight);

    img.style.maxHeight = "none";
    img.style.height = `${Math.floor(target)}px`;
    // Let the browser pick a larger srcset candidate than the one WordPress
    // sized for, so upscaled images stay sharp.
    if (img.srcset) {
      img.sizes = `${Math.ceil((target * naturalWidth) / naturalHeight)}px`;
    }
  });
}

export default function NewsModal(props) {
  const itemprops = props.itemProps;
  const bodyRef = useRef(null);

  useEffect(() => {
    const body = bodyRef.current;
    if (!body) return;
    const fit = () => fitImages(body);
    fit();
    // Re-fit as images finish loading (WordPress marks them lazy) and on resize.
    body.addEventListener("load", fit, true);
    window.addEventListener("resize", fit);
    return () => {
      body.removeEventListener("load", fit, true);
      window.removeEventListener("resize", fit);
    };
  }, [itemprops.itemContent]);

  return (
    <>
      <div className="news-modal-item-container">
        <div className="heading-section">
          <div
            className="modal-title section-heading"
            dangerouslySetInnerHTML={{ __html: itemprops.itemTitle }}
          ></div>
          <div className="news-modal-date">{itemprops.itemDate}</div>
        </div>
        <div
          ref={bodyRef}
          className="news-modal-item-text"
          dangerouslySetInnerHTML={{ __html: itemprops.itemContent }}
        ></div>
      </div>
    </>
  );
}
